<template>
  <div id="users" class="p-4">
    <div class="card w-100">
      <div class="card-header py-3">
        <div class="pt-2 font-bold text-uppercase">Sections</div>
      </div>
      <div class="card-body p-0">
        <!--<button class="btn btn-create my-2 ml-4" @click="onShowCreateModal()">+ Add Section</button>!-->
        <ul class="list-group list-group-flush">
          <v-draggable v-model="sections"
                       draggable=".list-group-item"
                       handle=".handle"
                       tag="tbody"
                       class="table__tbody"
                       @sort="onSortSections($event, sections)">
            <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                v-for="section of sections"
                :key="section.id">
              <span>
                <span class="handle cursor-pointer pr-2">
                  <img src="../assets/img/sort-icon.png">
                </span>
                {{ section.name }}
              </span>
              <span class="cursor-pointer" @click="onShowEditModal(section)">
                <img src="../assets/img/edit-icon.png">
              </span>
            </li>
          </v-draggable>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'

  export default {
    name: 'Sections',
    data() {
      return {
        sections: []
      }
    },
    computed: {
      ...mapGetters([
        'getSections',
      ])
    },
    mounted() {
      this.querySections()
    },
    watch: {
      getSections(val) {
        this.sections = val
      }
    },
    methods: {
      ...mapActions([
        'querySections',
        'sortSections',
        'showModal',
      ]),
      onShowCreateModal() {
        this.showModal({modal: 'ModalSection', data: {}})
      },
      onShowEditModal(sections) {
        this.showModal({modal: 'ModalSection', data: sections})
      },
      onSortSections(event, sections) {
        this.sortSections(sections)
      },
    }
  }
</script>

<style scoped>

</style>
